const state = () => ({
	ldapConfig: null,
	authConfig: null
});

const getters = {
	getLdapConfig: (state) => {
		return state.ldapConfig;
	},
	getAuthConfig: (state) => {
		return state.authConfig;
	}
};

const mutations = {
	setLdapConfig (state, config) {
		state.ldapConfig = config;
	},
	setAuthConfig (state, config) {
		state.authConfig = config;
	}
};

const actions = {
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
